var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { sanitizeBaseUrl } from "../../../utils";
import { messagingFormCreateMessage } from "../../evo-client/__generated__";
import { createClient, createConfig } from "../../evo-client/__generated__/client";
export class OmpApiEvo {
    constructor(ompServiceUrl, tenantToken, recaptchaId) {
        this.tenantToken = tenantToken;
        this.recaptchaId = recaptchaId;
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(ompServiceUrl), throwOnError: true }));
    }
    sendMessage(data_1) {
        return __awaiter(this, arguments, void 0, function* (data, type = "CONTACT") {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { collection_point_token, consent_purposes, channel, user } = data, rest = __rest(data, ["collection_point_token", "consent_purposes", "channel", "user"]);
            const { response } = yield messagingFormCreateMessage({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                body: Object.assign({ user,
                    type,
                    channel, payload: rest, collection_point_token,
                    // @ts-expect-error todo evo schema expects string with comma seperated purposes, but if we send string in payload, then evo returns message "The consent purposes must be an array."
                    consent_purposes }, ((data === null || data === void 0 ? void 0 : data.email) && { data_subject: data.email })),
            });
            return Promise.resolve({
                statusCode: response.status,
            });
        });
    }
}
//# sourceMappingURL=OmpApiEvo.js.map